import React from "react";

import { IconButton as MuiIconButton } from "@mui/material";
import clsx from "clsx";

import {
  useContainedIconButtonStyles,
  useIconButtonStyles,
} from "./base/styles";
import { BaseVariantIconButtonProps } from "./base/types";

export const ContainedIconButton: React.FC<BaseVariantIconButtonProps> = ({
  size = "default",
  icon,
  variant = "primary",
}) => {
  const { classes } = useIconButtonStyles();
  const { classes: variantClasses } = useContainedIconButtonStyles();

  const getButtonStyles = () => {
    let className;
    let muiSize: "small" | "medium" | "large" = "medium";

    switch (size) {
      case "tiny":
        className = classes.tiny;
        break;
      case "smallest":
        className = classes.smallest;
        break;
      case "smaller":
        className = classes.smaller;
        muiSize = "medium";
        break;
      case "small":
        muiSize = "small";
        break;
      case "default":
        muiSize = "medium";
        break;
      case "large":
        muiSize = "large";
        break;
      case "larger":
        className = classes.larger;
        muiSize = "large";
        break;
    }

    return { className, muiSize };
  };

  const getButtonColors = () => {
    switch (variant) {
      case "error":
        return variantClasses.error;
      case "warning":
        return variantClasses.warning;
      case "neutral":
        return variantClasses.neutral;
      case "primary":
      default:
        return variantClasses.primary;
    }
  };

  const { className, muiSize } = getButtonStyles();

  return (
    <MuiIconButton
      className={clsx(className, getButtonColors())}
      size={muiSize}
    >
      {icon}
    </MuiIconButton>
  );
};
